export default __webpack_public_path__ + "static/media/FooterLogo@3x.33f4c480.png";